// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appVersion: require("../../package.json").version + "-dev",
  coName: "Chedid KSA",
  supportEmail: "Support@oasisoft.net",
  production: false,
  // baseURL: "https://localhost:7233/api/v1",
  // baseURL: "https://localhost:44379/api/v1",
  baseURL: "https://chedid-api.oasisoft.net/api/v1",
  // baseURL: "https://oasisibs-api.chedid-insurance.com.sa/api/v1",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
